import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, Section, InputTextarea } from 'components'
import { DebounceInput } from 'react-debounce-input'

export default class ModalReject extends PureComponent {
  static propTypes = {
    onClickConfirm: PropTypes.func.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onChangeTextArea: PropTypes.func.isRequired,
    valueTaxeArea: PropTypes.string.isRequired,
  }

  state = {
    reason: '',
  }

  onClickConfirm = () => {
    this.props.onClickConfirm()
    // this.props.toggleModal()
  }

  onClickCancel = () => {
    this.props.onClickCancel()
    this.props.toggleModal()
  }

  onChage = event => {
    // this.setState({ reason: event.target.value })
    this.props.onChangeTextArea(event)
  }

  render() {
    const {
      isOpen,
      companyName,
      taxId,
      onChangeTextArea,
      valueTextArea,
      headerTitle,
    } = this.props
    return (
      <Modal
        id="reject_supplier_id"
        className="theme-blue modal-reject-supplier"
        isOpen={isOpen}
        modalWidth="768px"
      >
        <Modal.Header>{headerTitle} Supplier</Modal.Header>

        <Modal.Body>
          <Section className="form-group">
            <label>Tax ID:</label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper text">
                {taxId}
              </Section>
            </Section>
          </Section>

          <Section className="form-group">
            <label>Company Name:</label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper text">
                {companyName}
              </Section>
            </Section>
          </Section>

          <Section className="form-group">
            <label>Company Name:</label>
            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper ">
                <DebounceInput
                  id="reason"
                  className="reason"
                  type="text"
                  onChange={onChangeTextArea}
                  value={valueTextArea}
                  debounceTimeout={500}
                  element={InputTextarea}
                />
              </Section>
              <Section className="message ">Erorr message</Section>
            </Section>
          </Section>

          {/* <Section className="form-group">
            <label>Tax ID:</label>

            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">
                <div className="data">{taxId}</div>
              </Section>
            </Section>
          </Section>

          <Section className="form-group">
            <label>Company Name:</label>

            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper">
                <div className="data">{companyName}</div>
              </Section>
            </Section>
          </Section>

          <Section className="form-group is-error">
            <label>Reason:</label>

            <Section className="form-group-control">
              <Section className="form-group-inner-wrapper ">
                <DebounceInput
                  id="reason"
                  className="reason"
                  type="text"
                  onChange={onChangeTextArea}
                  value={valueTextArea}
                  debounceTimeout={500}
                  element={InputTextarea}
                />
              </Section>
              <Section className="message ">Erorr message</Section>
            </Section>
          </Section> */}
        </Modal.Body>

        <Modal.Footer>
          <Button
            id="close_modal_history_id"
            className="theme-border-gray"
            onClick={() => this.onClickCancel()}
          >
            Cancel
          </Button>

          <Button
            id="close_modal_history_id"
            className="theme-green"
            onClick={() => {
              this.onClickConfirm()
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
ModalReject.defaultProps = {
  onClickCancel: () => {},
  onClickConfirm: () => {},
  isOpen: false,
  companyName: '',
  onChangeTextArea: () => {},
  valueTaxeArea: '',
}
